import { useEffect, useRef } from 'react';
import { useBloco, urlWhatsapp } from '../content';

export default function Hero() {
  const bgRef = useRef(null);
  const c = useBloco('home.hero');

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY;
      const img = bgRef.current?.querySelector('.hero-img');
      if (img) img.style.transform = `translateY(${y * 0.38}px) scale(${1 + y * 0.00015})`;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <section className="hero">
      <div className="hero-bg" ref={bgRef}>
        <div
          className="hero-img"
          aria-hidden="true"
          style={{ backgroundImage: `url(${process.env.PUBLIC_URL}${c.image})` }}
        />
      </div>
      <div className="hero-overlay" />

      <div className="hero-content">
        <div className="hero-meta">
          <span className="live-dot" />
          <span>{c.metaLeft}</span>
          <span style={{ opacity: 0.4 }}>·</span>
          <span>{c.metaRight}</span>
        </div>

        <div className="hero-bottom">
          <p className="hero-lead">{c.lead}</p>
          <div className="hero-actions">
            <a
              href={urlWhatsapp('comercial')}
              target="_blank" rel="noopener noreferrer"
              className="btn-white"
            >
              {c.ctaPrimary}
            </a>
            <a href="#servicos" className="btn-ghost-w">{c.ctaSecondary}</a>
          </div>
        </div>
      </div>

      <div className="scroll-hint">
        <span>{c.scrollHint}</span>
        <div className="scroll-line" />
      </div>
    </section>
  );
}